'use client';

import { FC, useEffect, useState } from 'react';
import { OrderForm } from '@/lib/components/OrderForm/OrderForm';
import { OrderFormDesktopContainer } from '@/lib/components/OrderForm/OrderFormDesktopContainer';
import { OrderFormMobileContainer } from '@/lib/components/OrderForm/OrderFormMobileContainer';

interface OrderFormContainerProps {
  outcomesCount: number;
}

export const OrderFormContainer: FC<OrderFormContainerProps> = ({ outcomesCount }) => {
  const [isMobileView, setIsMobileView] = useState(false);

  // Check if window width is less than 1024px
  useEffect(() => {
    const checkWidth = () => {
      setIsMobileView(window.innerWidth < 1024);
    };

    // Check on mount
    checkWidth();

    // Add resize listener
    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  }, []);

  return isMobileView ? (
    <OrderFormMobileContainer>
      <OrderForm />
    </OrderFormMobileContainer>
  ) : (
    // 116px matches the `sticky top-[116px]` wrapper in EventPageContent;
    // items-start lets the card keep natural height so the whole form scrolls as one.
    <div className="scrollbar-hide -mx-5 flex max-h-[calc(100dvh-116px)] items-start overflow-y-auto px-5 py-6">
      <OrderFormDesktopContainer outcomesCount={outcomesCount}>
        <OrderForm />
      </OrderFormDesktopContainer>
    </div>
  );
};
